import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import FormControl from '@material-ui/core/FormControl';
import MUISelect from '@material-ui/core/Select';
import { MenuItem, ListSubheader, makeStyles } from '@material-ui/core';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputAdornment from '@material-ui/core/InputAdornment';
import LockIcon from '@material-ui/icons/Lock';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import FormContext from '../FormContext';

const useStyles = makeStyles(theme => ({
  selectRoot: {
    background: theme.palette.grey[50]
  },
  formControlRoot: {
    '& .MuiFilledInput-root.Mui-disabled': {
      background: theme.palette.grey[50]
    }
  },
  header: {
    '&.MuiListSubheader-root': {
      backgroundColor: theme.palette.grey[100],
      paddingLeft: theme.spacing(3)
    }
  }
}));

const SelectMultiField = ({
  label,
  dataField,
  fieldProps = '',
  items = [],
  helperText,
  disabled = false,
  initialValue = '',
  onChange
}) => {
  const classes = useStyles();
  const { getFieldValue, setFieldValue } = useContext(FormContext);
  const [selectedValue, setSelectedValue] = useState(
    initialValue ? initialValue : ''
  );
  const selectId = `form-field/${dataField}`;
  const allOptions = items.length && items.flatMap(group => group.options);

  const handleChange = event => {
    const selectedId = event.target.value;
    setSelectedValue(selectedId);

    const selectedItem = allOptions.find(
      item => item.value.piaProductArea === selectedId
    );

    if (onChange) {
      onChange(selectedItem.value); // full object
      return;
    }

    if (selectedItem && typeof selectedItem.value === 'object') {
      Object.entries(selectedItem.value).forEach(([key, fieldValue]) => {
        const fieldKey = fieldProps ? `${fieldProps}.${key}` : key;
        setFieldValue(fieldKey, fieldValue);
      });
    } else {
      setFieldValue(dataField, selectedId);
    }
  };

  const getEndAdornment = () =>
    disabled ? (
      <InputAdornment position="end">
        <LockIcon />
      </InputAdornment>
    ) : null;

  const getIconComponent = () => (disabled ? () => <></> : ArrowDropDownIcon);
  console.log(selectedValue, 'pia');

  return (
    <FormControl
      margin="normal"
      fullWidth
      variant="filled"
      classes={{ root: classes.formControlRoot }}
    >
      <InputLabel htmlFor={selectId}>
        <FormattedMessage id={label} />
      </InputLabel>
      <MUISelect
        id={selectId}
        classes={{ root: classes.selectRoot }}
        value={selectedValue || ''}
        onChange={handleChange}
        disabled={disabled}
        endAdornment={getEndAdornment()}
        IconComponent={getIconComponent()}
      >
        {(items && items.length) > 0 &&
          items.flatMap(group => [
            <ListSubheader
              key={`group-header-${group.header}`}
              className={classes.header}
            >
              {group.header}
            </ListSubheader>,
            ...group.options.map(item => (
              <MenuItem
                key={item.value.piaProductArea}
                value={item.value.piaProductArea}
              >
                {item.label}
              </MenuItem>
            ))
          ])}
      </MUISelect>
      <FormHelperText>
        <FormattedMessage id={helperText} />
      </FormHelperText>
    </FormControl>
  );
};

SelectMultiField.propTypes = {
  label: PropTypes.string.isRequired,
  dataField: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  initialValue: PropTypes.any,
  onChange: PropTypes.func
};

export default SelectMultiField;
